import { render, staticRenderFns } from "./ExpertiseTabsList.vue?vue&type=template&id=734c8155&scoped=true"
import script from "./ExpertiseTabsList.vue?vue&type=script&lang=js"
export * from "./ExpertiseTabsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734c8155",
  null
  
)

export default component.exports